import { render, staticRenderFns } from "./BeModal.vue?vue&type=template&id=54ff815a&"
import script from "./BeModal.vue?vue&type=script&lang=js&"
export * from "./BeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports